<template>
  <modal-blank @close="$emit('close')">
    <div slot="body">
      <div>
        <!-- <h3 style="text-align: center; color:white">Preview</h3> -->
        <facebook-screen :pagename="selectedBot.pagename" @onScroll="onScroll">
          <div slot="body" style="position: relative;">
            <template v-if="!isComment">
              <div v-if="questions.length > 0">
                <div
                  class="message"
                  style="margin-top: 10px;margin-right: 10px;margin-bottom: 10px;float:right;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
                >
                  <div style="font-size: 12px;color:white">
                    <div style="padding: 5px 8px 6px;background-color:#3578e5">
                      <span style="line-height:15.36px;">
                        <specialtext :text="questions[qustion_index]"></specialtext>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="clearfix"></div>
              </div>
            </template>
            <div style="min-height: 300px; margin-top: 5px;" v-if="messages.length > 0">
              <div style="overflow-y: auto; overflow-x: hidden" class="left-align">
                <message-viewer
                  v-model="messages"
                  :size="'small'"
                  :showProfile="true"
                ></message-viewer>

                <div class="clearfix"></div>
              </div>
            </div>
            <div style="margin-top: 70px"></div>
          </div>

          <div slot="footer">
            <div
              slot="quick_reply"
              v-if="choice"
              v-show="isBottom"
              style="position:relative;margin-top: 15px;"
            >
              <div style="padding-bottom: 10px"></div>
              <template>
                <div
                  style="padding-top: 10px;padding-bottom: 10px;margin: auto;width: 100%;text-align:center; bottom: 0;overflow-x: auto; overflow-y: hidden;height: 40px;white-space: nowrap;"
                >
                  <ul style="margin: auto;padding: 0">
                    <li
                      v-for="(reply, index) in choice"
                      :key="'reply_' + index"
                      style="list-style-type: none;display:inline;padding: 5px 10px;border: 1px solid #0284ff;margin-right: 5px;border-radius: 20px;color:#0284ff;"
                    >
                      {{ reply.text }}
                    </li>
                  </ul>
                </div>
              </template>
            </div>
            <div style="border-top: 1px solid #eee;margin-bottom: -7px;">
              <img
                src="/static/img/assets/facebook_ui/iOS Composer Default.png"
                style="width: 100%"
                alt
              />
            </div>
          </div>
        </facebook-screen>
      </div>
    </div>
  </modal-blank>
</template>

<script>
import GenericViewer from '@/components/elements/GenericViewer'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import FacebookScreen from '@/components/elements/FacebookScreen'
import specialtext from '@/components/elements/specialtext'
import ModalBlank from '@/components/elements/ModalBlank'
import MessageViewer from '@/components/elements/MessageViewer'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import { mapGetters } from 'vuex'
export default {
  props: {
    messages: {
      default: [
        [
          {
            type: 'text',
            text: 'hello'
          }
        ]
      ]
    },
    choice: {
      default: []
    },
    questions: {
      default: []
    },
    comment: {
      default: undefined
    },
    isComment: {
      default: false
    }
  },
  data: function() {
    return {
      qustion_index: 0,
      isBottom: false
    }
  },
  components: {
    FacebookScreen,
    specialtext,
    ModalBlank,
    MessageViewer,
    GenericViewer,
    ViewCartSummaryViewer,
    IntentGetstarted
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage',
      setting: 'setting'
    })
  },
  mounted: function() {
    var vm = this
    if (vm.questions.length > 1) {
      setInterval(() => {
        if (vm.qustion_index === vm.questions.length - 1) {
          vm.qustion_index = 0
        } else {
          vm.qustion_index++
        }
      }, 5000)
    }
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.isBottom = true
      } else {
        this.isBottom = false
      }
    }
  },
  watch: {
    messages: function() {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/PreviewMessage.vue